export const sendSiteimproveEvent = (category: string, action: string, label?: string) => {
  const event = label !== undefined ? ["event", category, action, label] : ["event", category, action];
  if ((window as any)._sz) (window as any)._sz.push(event);
};
